import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function OsnoviEkonomije() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Osnovi ekonomije" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Osnovi ekonomije</h2>
              <p>
                <strong>Studijski program:</strong> Računovodstvo finansije i
                bankarstvo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Osnovi ekonomije
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Osnovni cilj predmeta je da studenti steknu osnovna ekonomska
                znanja sposobnosti i vještine. „Ekonomija proučava čovječanstvo
                u svakodnevnom životu“ napisao je još u XIX vijeku Alfred Maršal
                te je stoga cilj da studenti ovladaju sposobnošću da proučavaju
                svakodnevnicu. Cilj predmeta je da studente osposobimo da
                razumiju kako savremena (ekonomska) društva odnosno ljudi
                alociraju oskudne resurse da bi stvorili alternativne
                vrijednosti i izvršili raspodjelu vrijednosti razmjenu i
                potrošnju kako sadašnju tako i buduću među različitim ljudima i
                društvenim grupacijama.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Očekivani rezultati jesu da studenti ovladaju osnovnim
                ekonomskim principima iz mikro i makroekonomije korišćenjem
                savremenih teorijskih saznanja i praktičnih primjera iz javnog i
                privatnog sektora tržišne ekonomije. Na osnovu stečenih znanja
                studenti su osposobljeni za razumijevanje svijeta u kome žive i
                zaintrigirani na ekonomsku radoznalost. Takođe očekuje se da
                studenti ovladaju sposobnošću da pronicljivo donose svakodnevne
                ekonomske odluke kao i da razumiju i aktivno promišljaju o
                mogućnostima i ograničenjima ekonomskih politika. Očekivani
                ishod je sposobnost profitabilnog odlučivanja u kratkoročnom i
                dugoročnom vremenskom periodu u korporativnom i globalnom
                okruženju.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Principi ekonomije (osnovni ekonomski principi: kako ljudi
                donose odluke kako djeluju jedni na druge i kako privreda
                funkcioniše kao cjelina) ; Trgovina međuzavisnost i benefiti od
                trgovine (moderna privreda komparativne prednosti); Ponuda
                tražnja tržište (tržišne sile ponude i tražnje cijene
                konkurencija alokacija resursa) ; Elastičnost; instrumenti
                ekonomske analize Tržište cijene i konkurencija ponuda i tražnja
                elastičnost tražnje i ponude; Racionalni izbor potrošača; Kriva
                tražnje normalna izuzeci od opšeg zakona tražnje potrošačev
                višak izbor u uslovima sigurnosti i nesigurnosti; Ponuda
                preduzeća na konkurentnom tržištu troškovi proizvodnje i prihodi
                minimiziranje troškova putanja ekspanzije kratkoročni i
                dugoročni troškovi ukupan profit profit po jedinici proizvoda
                gubitak maksimiranje profita tržišna efikasnost; Nepotpuna
                konkurencija monopol diskriminaciona cijena oligopolističko
                utvrđivanje cijena prirodni monopol i regulative oligopol
                monopolistička konkurencija monopolska cijena i maksimiranje
                profita; Teorija izbora potroša; Ekonomija javnog sektora
                (eksternalije javna dobra i zajednički resursi); Ekonomija
                tržišta rada (Tržište radne snage i minimalna plata ravnoteža na
                tržištu rada dohodna nejednakost sirumaštvo); Nezaposlenost
                prirodna stopa nezaposlenosti i odnos inflacije i
                nezaposlenosti; Inflacija deficit javne potrošnje;
                Makroekonomsko mjerenje rezultata nacionalne ekonomije
                (nacionalni dohodak mjerenje bruto domaćeg proizvoda realni i
                nominalni BDP BDP i ekonomsko blagostanje; Realna ekonomija
                (privredni rast produktivnost štednja investicije i finansijski
                sistem); Monetarni sistem (novac uloga centralnih banaka banke i
                ponuda novca rast novca i inflacija); Ekonomske fluktuacije
                (opšta ravnoteža efekat multiplikatora i ekceleratora agregatna
                tražnja i agregatna ponuda uticaj monetarne i fiskalne politike
                na agregatnu tražnju); Inflacija i nezaposlenost (filipsova
                kriva u kratkom i dugom roku);
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: predavanja, vježbe i
                konsultacije. U izvođenju nastave na predmetu osnove ekonomije
                koriste se savremene metode izvođenja nastave. To se postiže
                upotrebom savremenih alata i tehnika. Predavanja i vježbe
                organizovani su u slušaonama, a nekada i eksterno u toku
                studijskih posjeta privrednim subjektima. Sofisticirani
                pedagoški pristup nastavi podrazumijeva adekvatnu i kvalitetnu
                pripremu predavanja kako u smislu sadržaja, tako i u
                metodološkom smislu. Korišćenjem konvencionalnih i savremenih
                alata i tehnika postiže se optimalan balans. Upotreba
                informaciono komunikacionih tehnologija je imperativ
                osavremenjivanja nastave. Upotreba raznih prezentacija,
                infografika, naučnih portala i korišćenje društvenih mreža,
                YouTube kanala, mobilnih aplikacija, vještačke inteligencije kao
                i online povezivanje su neophodni u nastavi. Takođe, korišćenje
                filma kao metode izvođenja nastave sastavni je dio predavanja
                ili kao domaći zadatak. U realizaciji predavanja i vježbi
                učestvuju predmetni nastavnici i saradnici, kao i gostujući
                profesori i istaknuti stručnjaci iz privrede. U nastavi se na
                kreativan način koriste kontrolisani eksperimenti, razne
                simulacije, pregled štampe i aktuelnosti, zanimljive igre i
                kvizovi.
              </p>

              <h3 className="pb-10">Plan rada</h3>

              <table className="table table-bordered mb-40 ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P + 2V</td>
                    <td>
                      Principi ekonomije (osnovni ekonomski principi: kako ljudi
                      donose odluke kako djeluju jedni na druge i kako privreda
                      funkcioniše kao cjelina)
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P + 2V</td>
                    <td>
                      Trgovina međuzavisnost i benefiti od trgovine (moderna
                      privreda komparativne prednosti); Ponuda tražnja tržište
                      (tržišne sile ponude i tražnje cijene konkurencija
                      alokacija resursa)
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P + 2V</td>
                    <td>Elastičnost</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P + 2V</td>
                    <td>
                      Instrumenti ekonomske analize Tržište cijene i
                      konkurencija ponuda i tražnja elastičnost tražnje i ponude
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P + 2V</td>
                    <td>
                      Racionalni izbor potrošača; Kriva tražnje normalna izuzeci
                      od opšeg zakona tražnje potrošačev višak izbor u uslovima
                      sigurnosti i nesigurnosti
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P + 2V</td>
                    <td>
                      Ponuda preduzeća na konkurentnom tržištu troškovi
                      proizvodnje i prihodi minimiziranje troškova putanja
                      ekspanzije kratkoročni i dugoročni troškovi ukupan profit
                      profit po jedinici proizvoda gubitak maksimiranje profita
                      tržišna efikasnost
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P + 2V</td>
                    <td>
                      Nepotpuna konkurencija monopol diskriminaciona cijena
                      oligopolističko utvrđivanje cijena prirodni monopol i
                      regulative oligopol monopolistička konkurencija monopolska
                      cijena i maksimiranje profita
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P + 2V</td>
                    <td>Teorija izbora potroša</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P + 2V</td>
                    <td>
                      Ekonomija javnog sektora (eksternalije javna dobra i
                      zajednički resursi)
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P + 2V</td>
                    <td>
                      Ekonomija tržišta rada (Tržište radne snage i minimalna
                      plata ravnoteža na tržištu rada dohodna nejednakost
                      sirumaštvo); Nezaposlenost prirodna stopa nezaposlenosti i
                      odnos inflacije i nezaposlenosti
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P + 2V</td>
                    <td>
                      Makroekonomska mjerenja rezultata nacionalne ekonomije
                      (nacionalni dohodak mjerenje bruto domaćeg proizvoda
                      realni i nominalni BDP BDP i ekonomsko blagostanje
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P + 2V</td>
                    <td>
                      Realna ekonomija (privredni rast produktivnost štednja
                      investicije i finansijski sistem); Monetarni sistem (novac
                      uloga centralnih banaka banke i ponuda novca rast novca i
                      inflacija)
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P + 2V</td>
                    <td>
                      Ekonomske fluktuacije (opšta ravnoteža efekat
                      multiplikatora i ekceleratora agregatna tražnja i
                      agregatna ponuda uticaj monetarne i fiskalne politike na
                      agregatnu tražnju); Inflacija i nezaposlenost (filipsova
                      kriva u kratkom i dugom roku)
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered mb-40 ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5 č / 225 min</td>
                            <td>Ukupno: 120 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 135 min</td>
                            <td>Nastava + završni ispit: 90 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 90 min</td>
                            <td>Priprema i ovjera semestra: 9 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 21 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default OsnoviEkonomije;
